import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import { createSite, deleteSites, fetchSite, fetchSites, updateSite } from '../actions/site';

const siteSlice = createSlice({
  name: 'site',
  initialState: {
    data: [],
    error: null,
    loading: false,
    site: null,
    sortedData: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    },
    resetSite: state => {
      state.site = null;
    }
  },
  extraReducers: builder => {
    builder
      // Create Site
      .addCase(createSite.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSite.fulfilled, (state, action) => {
        state.loading = false;
        state.site = action.payload;
      })
      .addCase(createSite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Sites
      .addCase(fetchSites.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Site
      .addCase(fetchSite.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSite.fulfilled, (state, action) => {
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.site = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchSite.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // Update Site
      .addCase(updateSite.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSite.fulfilled, (state, action) => {
        state.loading = false;
        state.site = action.payload;
      })
      .addCase(updateSite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Sites
      .addCase(deleteSites.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSites.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(record => !action.payload?.includes(record.id));
      })
      .addCase(deleteSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData, resetSite } = siteSlice.actions;
export default siteSlice.reducer;
